/* eslint-disable camelcase */
export const UpgamingSportPages = {
  HOME: 'home',
  LIVE: 'live',
  VIRTUAL: 'virtual',
  ESPORTS: 'esports',
  BET_HISTORY: 'bet-history',
} as const

export type UpgamingSportPagesType = ReverseMap<typeof UpgamingSportPages>

export const UpgamingThemes = {
  light: 'default-light-theme',
  dark: 'default-dark-theme',
} as const

export type UpgamingThemesType = ReverseMap<typeof UpgamingThemes>

export interface IServerResponseSession {
  token: string
  session_id: string
  url: string
}

export interface IConvertedSession {
  url: string
  token: string | null
}

export interface ICreateSessionPayload {
  is_mobile: boolean
  language: string
}

export interface IClearSessionPayload {
  token: string
}

export enum UpgamingRedirectUrls {
  CASINO = '/casino/casino',
  LIVE_CASINO = '/casino/livecasino',
  VIRTUAL = '/sportsbook/virtual',
  ESPORTS = '/sportsbook/esports',
}

export type UpgamingEventMessage = MessageEvent<
  | { msg: 'sport_redirect'; data: { url: UpgamingRedirectUrls } }
  | { msg: 'sport_urlchange'; url: string }
  | { msg: 'sport_notAuthorized' }
  | { msg: 'sport_betInfoShown' }
  | { msg: 'sport_betInfoHidden' }
  | { msg: 'sport_ticketPlaced' }
  | { msg: 'sport_betslipShown' }
  | { msg: 'sport_betslipHidden' }
>
